import React, {useEffect, useState} from 'react';
import {Collapse, Button, Card, CardBody} from 'reactstrap';
import styles from '@/views/Layout/b2b/ProducerNavBar/index.module.css';
import Icon from '@/views/shared/Icon';
import api from '@/api';

import {useProducerCtx} from '@/views/Layout/b2b/ProducerNavBar/state';
import {useTranslation} from 'react-i18next';

const ProducerTree = () => {
  const [state, dispatch] = useProducerCtx();
  const {t: tr} = useTranslation();
  const {producerId} = state;

  const [collapse, setCollapse] = useState(false);
  const handleToggle = () => {
    setCollapse(!collapse);
  };

  const getProducer = (obj, callback) => {
    const path =
      obj.id === '#'
        ? `/b2b/get_tree_node.json?load_parent=true&root_producer_id=${producerId}&id=${
            obj.id
          }`
        : `/b2b/get_tree_node.json?load_parent=false&root_producer_id=${producerId}&id=${
            obj.id
          }`;

    api.get(path).then(result => callback.call(this, result.data));
  };

  useEffect(() => {
    global.jQuery('#tree').jstree({
      core: {
        data: getProducer,
      },
    });

    global.jQuery('#tree').on('select_node.jstree', (evt, data) => {
      const newProducer = {
        producerId: data.node.id,
        producerName: data.node.a_attr.name,
        producerFullName: data.node.a_attr.fullname,
      };

      dispatch({type: 'changeProducer', newProducer});
      setCollapse(false);
    });
  }, []);

  const handleExpand = () => {
    global.jQuery('#tree').jstree('open_all');
  };

  const handleCollapse = () => {
    global.jQuery('#tree').jstree('close_all');
  };

  return (
    <>
      <Button
        className='btn ml-2 mb-1'
        style={{border: '1px solid #245a80', color: '#245a80'}}
        color='light'
        size='sm'
        onClick={handleToggle}
      >
        <span>
          <Icon icon='sitemap' />
        </span>
      </Button>
      <Collapse isOpen={collapse}>
        <Card className={styles.tree_card}>
          <CardBody className={styles.tree_section}>
            <div>
              <button
                type='button'
                onClick={handleExpand}
                className={`btn btn-primary btn-sm ${styles.btn_tree_sm}`}
              >
                {tr('common:expand_tree')}
              </button>
              <button
                type='button'
                onClick={handleCollapse}
                className={`btn btn-primary btn-sm ${styles.btn_tree_sm}`}
              >
                {tr('common:collapse_tree')}
              </button>
            </div>
            <div id='tree' />
          </CardBody>
        </Card>
      </Collapse>
    </>
  );
};

export default ProducerTree;
